export enum EventTypes {
  CarrierVisitUpsertedEvent = 'CarrierVisitUpsertedEvent',
  CarrierVisitDeletedEvent = 'CarrierVisitDeletedEvent',
  ContainerUpsertedEvent = 'ContainerUpsertedEvent',
  ContainerDeletedEvent = 'ContainerDeletedEvent',
  JourneyUpsertedEvent = 'JourneyUpsertedEvent',
  JourneyDeletedEvent = 'JourneyDeletedEvent',
  YardBlockDeletedEvent = 'YardBlockDeletedEvent',
  YardBlockUpsertedEvent = 'YardBlockUpsertedEvent',
  StackedInEvent = 'StackedInEvent',
  PierUpsertedEvent = 'PierUpsertedEvent',
  PierDeletedEvent = 'PierDeletedEvent',
  BerthUpsertedEvent = 'BerthUpsertedEvent',
  BerthDeletedEvent = 'BerthDeletedEvent',
  RailTrackUpsertedEvent = 'RailTrackUpsertedEvent',
  RailTrackDeletedEvent = 'RailTrackDeletedEvent',
  RoadNodeUpsertedEvent = 'RoadNodeUpsertedEvent',
  RoadNodeDeletedEvent = 'RoadNodeDeletedEvent',
  RoadSegmentUpsertedEvent = 'RoadSegmentUpsertedEvent',
  RoadSegmentDeletedEvent = 'RoadSegmentDeletedEvent',
  LayoutObjectUpsertedEvent = 'LayoutObjectUpsertedEvent',
  LayoutObjectDeletedEvent = 'LayoutObjectDeletedEvent',
  AllocationRuleUpsertedEvent = 'AllocationRuleUpsertedEvent',
  AllocationRuleDeletedEvent = 'AllocationRuleDeletedEvent',
  CreatedReservationEvent = 'CreatedReservationEvent',
  YardIssueUpsertedEvent = 'YardIssueUpsertedEvent',
  HousekeepingPlanUpsertedEvent = 'HousekeepingPlanUpsertedEvent',
}

export const eventsToListen: string[] = Object.values(EventTypes)
